<template>
  <div id="appWrap">
    <div class="contentWrapper">
      <!-- 画面中央に配置する内容 -->
      <div class="logoWrapper">
        <AppLogoText svg-width="100%" svg-height="auto" />
      </div>
      <div class="centerContent">
        <p>
          みののわラジオ放送局は、2026年10月3日をもちまして終了いたしました。<br />長らくのご愛顧、誠にありがとうございました。
        </p>
      </div>
    </div>
  </div>
  <!-- #appWrap -->
</template>

<script>
import AppLogoText from '@/components/AppLogoText.vue'

export default {
  name: 'App',
  components: {
    AppLogoText,
  },
}
</script>

<style>
#appWrap {
  min-height: 100vh;
}
.contentWrapper {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}
.logoWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.centerContent {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
